import { MouAcceptance } from './model/mou-acceptance.model';
import { MouService } from './../service/mou.service';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { robDecline, robSigned } from '../state/auth.actions';
import { MsgModel } from '../../common-components/msg/model/msg.model';

@Component({
    selector: 'app-rob-required',
    templateUrl: './rob-required.component.html',
    styleUrls: ['./rob-required.component.scss']
})
export class RobRequiredComponent implements OnInit {
    @ViewChild('top') topRef: ElementRef;
    signatureString: string = '';
    mouAcceptance: MouAcceptance = new MouAcceptance();

    isLoading: boolean = false;
    msg: MsgModel = new MsgModel();

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private store: Store<AppState>, private mouService: MouService) {}

    ngOnInit(): void {
        this.isLoading = true;

        this.getRobDocument();
    }

    getRobDocument() {
        this.mouService.getRobDocument().subscribe((res) => {
            if (res.robDocument) {
                this.mouAcceptance.MOU_DOCUMENTS_ID = res.robDocument.ID;
                const userToken = localStorage.getItem('userToken');
                if (userToken) {
                    const user = JSON.parse(userToken);
                    this.mouAcceptance.PARTIES_ID = user.user?.PERSON?.PARTy?.ID;
                }
            }

            setTimeout(() => {
                this.isLoading = false;
            }, 500);
        });
    }

    sign() {
        if (this.mouAcceptance.MOU_DOCUMENTS_ID && this.mouAcceptance.PARTIES_ID && this.signatureString) {
            this.mouAcceptance.SIGNATURE = this.signatureString;

            this.mouService.signDocument(this.mouAcceptance).subscribe((res) => {
                if (res.msg) {
                    if (res.msg.SUCCESS) {
                        this.store.dispatch(robSigned());
                    } else {
                        this.msg = res.MSG;
                    }
                } else {
                    this.msg.MSG = 'Error signing Rules of Behavior.';
                    this.msg.SUCCESS = false;
                }
            });
        }
    }

    decline() {
        this.store.dispatch(robDecline());
    }
}
